import Api from "../../../../https/Api";
import {
    CategoryInputs,
    EquipmentInputs,
} from "../../../../utils/AnnounceInterfaces";

export class EquipmentService {
    private api: Api;
    constructor() {
        this.api = new Api();
    }

    //get
    async getAllCategories() {
        return this.api.get("categories");
    }

    async getCategoryById(id: string) {
        return this.api.simpleGet("categories/get", id);
    }

    async getAllEquipments() {
        return this.api.get("equipments");
    }

    async getEquipmentById(id: string) {
        return this.api.simpleGet("equipments/get", id);
    }

    // Get all search types
    async getAllSearchTypes() {
        return this.api.get("searchTypes");
    }

    //post
    async saveCategory(category: CategoryInputs) {
        return this.api.post("categories/create/", category);
    }

    async saveEquipment(equipment: EquipmentInputs) {
        return this.api.post("equipments/create/", equipment);
    }

    //delete
    async deleteCategory(id: string) {
        return this.api.simpleDeleteById(`categories/delete`, id);
    }

    async deleteCategories(ids: string[]) {
        const param = {
            ids: ids,
        };
        return this.api.deleteMany("categories/deleteMany", param);
    }
    async deleteEquipment(id: string) {
        return this.api.simpleDeleteById(`equipments/delete`, id);
    }

    async deleteEquipments(ids: string[]) {
        const param = {
            ids: ids,
        };
        return this.api.deleteMany("equipments/deleteMany", param);
    }
}
